import { render } from "./swapPageTabs.vue?vue&type=template&id=58e5a5ce&scoped=true&lang=pug"
import script from "./swapPageTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./swapPageTabs.vue?vue&type=script&setup=true&lang=js"

import "./swapPageTabs.vue?vue&type=style&index=0&id=58e5a5ce&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e5a5ce"]])

export default __exports__